export const getQRCode = (data: string) => {
  const uri = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${data}`;
  return uri;
};
